import { Injectable } from '@angular/core'
import { ApiClient, ApiClientFactory, serializeHttpParams } from '@ftr/api-shared'
import { PagedResult } from '@ftr/contracts/api/core/response/PagedResult'
import { Recorder, RecorderCreateRequest, RecorderQueryRequest } from '@ftr/contracts/api/recorder'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult } from '@ftr/foundation'

@Injectable()
export class RecorderService {
  private readonly apiClient: ApiClient

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClient = apiClientFactory.build('/recorder')
  }

  getRecorders(params: RecorderQueryRequest): ApiResult<PagedResult<Recorder>> {
    return this.apiClient.get({ params: serializeHttpParams(params) })
  }

  createRecorder(recorder: RecorderCreateRequest): ApiResult<Recorder> {
    return this.apiClient.post({ body: recorder })
  }

  /**
   * Unlinking a department requires a department id, unlinking a location does not require any id.
   */
  unlinkRecorder(recorder: Recorder, departmentId?: Uuid): ApiResult<Recorder> {
    if (!departmentId) {
      return this.apiClient.post({ path: `${recorder.id}/unlink` })
    }
    return this.apiClient.post({ path: `${recorder.id}/unlinkDepartment`, body: { departmentId } })
  }
}
